import * as React from 'react'
import { FC, useCallback } from 'react'

import { ExternalLinkedApplication } from '@user/store/authorization'
import { getAppData } from './utils'
import { getStyles } from './styling'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

interface Props {
  app: ExternalLinkedApplication
  onClose: () => void
}

export const App: FC<Props> = (props) => {
  const { app, onClose } = props

  const { appName, appAbbreviation, onClick } = getAppData(app)

  const handleClick = useCallback(() => {
    onClick()
    onClose()
  }, [onClick, onClose])
  const styles = getStyles(useTheme())
  return (
    <Box
      sx={styles.appWrapper}
      onClick={handleClick}
      data-test-id={`appSwitch${appName}Btn`}
    >
      <Box sx={styles.avatar}>{appAbbreviation}</Box>
      <Typography sx={styles.appName} variant="caption">
        {appName}
      </Typography>
    </Box>
  )
}
App.displayName = 'App'
